"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9248,136,9901,3406,8487,3794],{

/***/ 89248:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(828);
/* harmony import */ var _codebuild_output_src4243868678_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _codebuild_output_src4243868678_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_codebuild_output_src4243868678_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _csc_dls_hooks__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5300);
/* harmony import */ var _helpers_checkIsExtendItem__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(40136);
/* harmony import */ var _helpers_allPromisesWithRetries__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(48080);
/* harmony import */ var _services_Log__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(27429);
/* harmony import */ var _helpers_checkIsShippedShieldItem__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(23406);
/* harmony import */ var _events_addToCartEvent__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(88487);














var Text = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(__webpack_require__.e(/* import() */ 5468).then(__webpack_require__.bind(__webpack_require__, 45468)), {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(45468)
            ];
        }
    }
});
var IconRenderer = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(__webpack_require__.e(/* import() */ 9821).then(__webpack_require__.bind(__webpack_require__, 99821)), {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(99821)
            ];
        }
    }
});
var Basket = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(__webpack_require__.e(/* import() */ 365).then(__webpack_require__.bind(__webpack_require__, 30365)), {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(30365)
            ];
        }
    }
});
var PreviewContent = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(__webpack_require__.e(/* import() */ 3074).then(__webpack_require__.bind(__webpack_require__, 33074)), {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(33074)
            ];
        }
    }
});
var functorMaybeEventStopper = function(fn) {
    return function(e) {
        var ref, ref1;
        e === null || e === void 0 ? void 0 : (ref = e.preventDefault) === null || ref === void 0 ? void 0 : ref.call(e);
        e === null || e === void 0 ? void 0 : (ref1 = e.stopPropagation) === null || ref1 === void 0 ? void 0 : ref1.call(e);
        fn();
    };
};
var getLineItems = function(cart) {
    return (cart === null || cart === void 0 ? void 0 : cart.lineItems.map(function(item) {
        return (0,_helpers_checkIsExtendItem__WEBPACK_IMPORTED_MODULE_7__.checkIsExtendItem)(item) ? (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, item), {
            imageUrl: "/__statics/images/extend_logo.png",
            isWarranty: true,
            extendedSalePrice: item.extendedListPrice,
            options: []
        }) : item;
    })) || [];
};
var getCartItemsQUantity = function(cart) {
    var lineItems = getLineItems(cart);
    var wfd = lineItems.some(_helpers_checkIsShippedShieldItem__WEBPACK_IMPORTED_MODULE_10__.checkIsShippedShieldItem);
    var withoutWfd = lineItems.filter(function(item) {
        return !(0,_helpers_checkIsShippedShieldItem__WEBPACK_IMPORTED_MODULE_10__.checkIsShippedShieldItem)(item);
    });
    return withoutWfd.reduce(function(item, next) {
        return item + next.quantity;
    }, wfd ? 1 : 0);
};
var CartPreview = function(param) {
    var cart = param.cart, onUpdateCart = param.onUpdateCart, pageType = param.pageType, _color = param.color, color = _color === void 0 ? "white" : _color, _iconSize = param.iconSize, iconSize = _iconSize === void 0 ? "md" : _iconSize;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), previewVisible = ref[0], setPreviewVisible = ref[1];
    var lineItems = getLineItems(cart);
    var quantity = getCartItemsQUantity(cart);
    var countPill = (typeof quantity === "number" ? quantity : "...").toString();
    var isAtTheTop = (0,_csc_dls_hooks__WEBPACK_IMPORTED_MODULE_4__/* .useScrollWatcher */ .d8)({}).isAtTheTop;
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if ( true && window.innerWidth >= 1024) {
            setPreviewVisible(previewVisible && isAtTheTop);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isAtTheTop
    ]);
    var openPreview = functorMaybeEventStopper(function() {
        if (!previewVisible) {
            setPreviewVisible(true);
        }
        if (true) {
            window.scrollTo(0, 0);
        }
        document.getElementsByTagName("body")[0].classList.add("has-cart");
    });
    var closePreview = functorMaybeEventStopper(function() {
        if (previewVisible) {
            setPreviewVisible(false);
        }
        document.getElementsByTagName("body")[0].classList.remove("has-cart");
    });
    var removeCoupon = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_codebuild_output_src4243868678_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var ref, ref1, ref2, ref3, removeCouponFromCart, getCart;
            return _codebuild_output_src4243868678_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        if (!(cart === null || cart === void 0 ? void 0 : (ref = cart.coupons) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.code)) {
                            _ctx.next = 17;
                            break;
                        }
                        _ctx.t0 = _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z;
                        _ctx.next = 5;
                        return (0,_helpers_allPromisesWithRetries__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                            return [
                                Promise.all(/* import() */[__webpack_require__.e(3714), __webpack_require__.e(8309), __webpack_require__.e(8764), __webpack_require__.e(8924), __webpack_require__.e(6511), __webpack_require__.e(1260), __webpack_require__.e(1570), __webpack_require__.e(4198), __webpack_require__.e(3830), __webpack_require__.e(6648), __webpack_require__.e(4578), __webpack_require__.e(1721), __webpack_require__.e(2264), __webpack_require__.e(6508), __webpack_require__.e(2275)]).then(__webpack_require__.bind(__webpack_require__, 46585)),
                                Promise.all(/* import() */[__webpack_require__.e(3714), __webpack_require__.e(8309), __webpack_require__.e(8764), __webpack_require__.e(6511), __webpack_require__.e(9591)]).then(__webpack_require__.bind(__webpack_require__, 36511)), 
                            ];
                        });
                    case 5:
                        _ctx.t1 = _ctx.sent;
                        ref2 = (0, _ctx.t0)(_ctx.t1, 2);
                        ref3 = ref2[0];
                        removeCouponFromCart = ref3.default;
                        getCart = ref2[1].getCart;
                        _ctx.next = 12;
                        return removeCouponFromCart({
                            cartId: cart.id,
                            couponCode: cart.coupons[0].code
                        });
                    case 12:
                        _ctx.t2 = onUpdateCart;
                        _ctx.next = 15;
                        return getCart();
                    case 15:
                        _ctx.t3 = _ctx.sent;
                        (0, _ctx.t2)(_ctx.t3);
                    case 17:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function removeCoupon() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        var addToCartEventHandler = function() {
            setPreviewVisible(true);
        };
        document.addEventListener(_events_addToCartEvent__WEBPACK_IMPORTED_MODULE_13__.ADD_TO_CART_EVENT_NAME, addToCartEventHandler);
        return function() {
            document.removeEventListener(_events_addToCartEvent__WEBPACK_IMPORTED_MODULE_13__.ADD_TO_CART_EVENT_NAME, addToCartEventHandler);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        quantity,
        _events_addToCartEvent__WEBPACK_IMPORTED_MODULE_13__.ADD_TO_CART_EVENT_NAME,
        setPreviewVisible
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (previewVisible && typeof window.hj === "function") {
            try {
                window.hj("vpv", "/cart-preview");
                window.hj("tagRecording", [
                    "Cart Preview opened"
                ]);
            } catch (e) {
                (0,_services_Log__WEBPACK_IMPORTED_MODULE_6__/* .error */ .vU)("Couldn't log to hotjar");
            }
        }
    }, [
        previewVisible
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("li", {
        className: "relative navUser-item navUser-item--cart",
        style: {
            maxHeight: "20px"
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("button", {
                className: "relative",
                "data-cart-preview": true,
                type: "button",
                "aria-label": "cart-preview-dropdown",
                "data-dropdown": "cart-preview-dropdown",
                "data-options": "align:right",
                onClick: openPreview,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(IconRenderer, {
                        IconComponent: Basket,
                        size: iconSize,
                        color: color,
                        className: "text-white lg:hidden"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(IconRenderer, {
                        IconComponent: Basket,
                        size: "md",
                        color: color,
                        className: "text-white hidden lg:block"
                    }),
                    quantity > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Text, {
                        size: "sm",
                        "data-testid": "cart-quantity-count-pill",
                        className: "absolute bg-secondary h-5 w-5 text-center text-white rounded-full -right-1 -top-1 transform translate-x-1/2 -translate-y-1/2 cart-quantity",
                        children: countPill
                    })
                ]
            }),
            pageType !== "cart" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(PreviewContent, {
                cart: cart,
                visible: previewVisible,
                lineItems: lineItems,
                onClose: closePreview,
                removeCoupon: removeCoupon,
                onUpdateCart: onUpdateCart
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (CartPreview);


/***/ }),

/***/ 88487:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ADD_TO_CART_EVENT_NAME": function() { return /* binding */ ADD_TO_CART_EVENT_NAME; },
/* harmony export */   "createAddToCartEvent": function() { return /* binding */ createAddToCartEvent; }
/* harmony export */ });
var ADD_TO_CART_EVENT_NAME = "addToCartEvent";
//
var createAddToCartEvent = function() {
    return new Event(ADD_TO_CART_EVENT_NAME);
};


/***/ }),

/***/ 51250:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ EXTEND_SKU; }
/* harmony export */ });
var EXTEND_SKU = ";xtd;";


/***/ }),

/***/ 49125:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ SHIPPED_SHIELD_SKU; }
/* harmony export */ });
var SHIPPED_SHIELD_SKU = "WORRY_FREE_DELIVERY";


/***/ }),

/***/ 68533:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ WORRY_FREE_DELIVERY_SKU; }
/* harmony export */ });
var WORRY_FREE_DELIVERY_SKU = "WORRY_FREE_DELIVERY";


/***/ }),

/***/ 40136:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "checkIsExtendItem": function() { return /* binding */ checkIsExtendItem; }
/* harmony export */ });
/* harmony import */ var _data_constants_EXTEND_SKU__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(51250);

var checkIsExtendItem = function(variant) {
    return "".concat(variant.sku).includes(_data_constants_EXTEND_SKU__WEBPACK_IMPORTED_MODULE_0__/* .EXTEND_SKU */ .J);
};
/* harmony default export */ __webpack_exports__["default"] = (checkIsExtendItem);


/***/ }),

/***/ 23406:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "checkIsShippedShieldItem": function() { return /* binding */ checkIsShippedShieldItem; },
/* harmony export */   "hasShippedShieldItem": function() { return /* binding */ hasShippedShieldItem; }
/* harmony export */ });
/* harmony import */ var _data_constants_SHIPPED_SHIELD_SKU__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49125);
/* harmony import */ var _data_constants_WORRY_FREE_DELIVERY_SKU__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(68533);


var checkIsShippedShieldItem = function(variant) {
    return "".concat(variant.sku).includes(_data_constants_SHIPPED_SHIELD_SKU__WEBPACK_IMPORTED_MODULE_0__/* .SHIPPED_SHIELD_SKU */ .E) || "".concat(variant.sku).includes(_data_constants_WORRY_FREE_DELIVERY_SKU__WEBPACK_IMPORTED_MODULE_1__/* .WORRY_FREE_DELIVERY_SKU */ .f);
};
/* harmony default export */ __webpack_exports__["default"] = (checkIsShippedShieldItem);
var hasShippedShieldItem = function(variants) {
    return variants.some(checkIsShippedShieldItem);
};


/***/ }),

/***/ 5300:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;

__webpack_unused_export__ = ({
    value: true
});
var react = __webpack_require__(67294);
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
var isVisibleEvents = [
    "scroll",
    "resize",
    "orientationchange",
    "mousemove",
    "mouseover",
    "mouseout",
    "mouseenter",
    "mouseleave",
    "mousedown",
    "mouseup",
    "mousewheel",
    "focus",
    "focusin",
    "focusout",
    "compositionstart",
    "compositionupdate",
    "animationstart",
    "animationend",
    "pointermove",
    "click",
    "touchstart",
    "touchend",
    "touchcancel",
    "touchmove",
    "gesturestart",
    "gestureend",
    "gesturechange",
    "transitionstart",
    "transitionend"
];
var callBackWithRetries = function callBackWithRetries(callback) {
    return function(event) {
        callback(event);
        var interval = setInterval(function() {
            return callback(event);
        }, 300);
        setTimeout(function() {
            clearInterval(interval);
        }, 6000);
    };
};
var tryRegisteringWindowEvent = function tryRegisteringWindowEvent(callback) {
    return function(event) {
        try {
            window.addEventListener(event, callBackWithRetries(callback), {
                passive: true
            });
        } catch (e) {
            console.error(e);
        }
    };
};
var tryDeregisteringWindowEvent = function tryDeregisteringWindowEvent(callback) {
    return function(event) {
        try {
            window.removeEventListener(event, callback);
        } catch (e) {
            console.error(e);
        }
    };
};
var useIsVisible = function useIsVisible(previewElement) {
    var _a = __read(react.useState(false), 2), isVisible = _a[0], setIsVisible = _a[1];
    var isElementVisible = react.useCallback(function(_a) {
        var _b = _a.window, innerHeight = _b.innerHeight, innerWidth = _b.innerWidth, _c = _a.document.documentElement, clientHeight = _c.clientHeight, clientWidth = _c.clientWidth;
        if (!previewElement.current) {
            return false;
        }
        var _d = previewElement.current.getBoundingClientRect(), top = _d.top, left = _d.left, bottom = _d.bottom, right = _d.right;
        var height = innerHeight || clientHeight;
        var width = innerWidth || clientWidth;
        var verticallyInside = function verticallyInside(spot) {
            return spot >= 0 && spot <= height;
        };
        var horizontallyInside = function horizontallyInside(spot) {
            return spot >= 0 && spot <= width;
        };
        var topInside = verticallyInside(top);
        var bottomInside = verticallyInside(bottom);
        var leftInside = horizontallyInside(left);
        var rightInside = horizontallyInside(right);
        return topInside && leftInside || topInside && rightInside || bottomInside && leftInside || bottomInside && rightInside;
    }, [
        previewElement
    ]);
    var startLoadIfVisible = react.useCallback(function(_a) {
        var window1 = _a.window, document1 = _a.document;
        if (!isVisible && isElementVisible({
            window: window1,
            document: document1
        })) {
            setIsVisible(true);
        }
    }, [
        isElementVisible,
        isVisible
    ]);
    react.useEffect(function() {
        var loadBasedOnPosition = function loadBasedOnPosition() {
            return startLoadIfVisible({
                window: window,
                document: document
            });
        };
        loadBasedOnPosition();
        if (!isVisible) {
            isVisibleEvents.forEach(tryRegisteringWindowEvent(loadBasedOnPosition));
        }
        return function() {
            isVisibleEvents.forEach(tryDeregisteringWindowEvent(loadBasedOnPosition));
        };
    }, [
        startLoadIfVisible,
        isVisible
    ]);
    return isVisible;
};
function useScrollWatcher(_a) {
    var _b = _a.id, id = _b === void 0 ? "" : _b;
    var _c = __read(react.useState(0), 2), scrollTop = _c[0], setScrollTop = _c[1];
    var _d = __read(react.useState(1), 2), verticalHeight = _d[0], setVerticalHeight = _d[1];
    var _e = __read(react.useState(false), 2), isScrollingUp = _e[0], setIsScrollingUp = _e[1];
    react.useEffect(function() {
        var onScroll = function onScroll(e) {
            if (typeof document !== "undefined" && "object" !== "undefined") {
                var currentScrollTop = window.scrollY;
                var currentVerticalHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
                setScrollTop(currentScrollTop);
                setVerticalHeight(currentVerticalHeight);
                if (currentVerticalHeight === verticalHeight) {
                    var currentIsScrollingUp = currentScrollTop <= 0 || currentScrollTop < scrollTop;
                    setIsScrollingUp(currentIsScrollingUp);
                }
            }
        };
        if (typeof document !== "undefined" && "object" !== "undefined") {
            window.addEventListener("scroll", onScroll);
            return function() {
                return window.removeEventListener("scroll", onScroll);
            };
        }
    }, [
        id,
        scrollTop,
        verticalHeight
    ]);
    var isAtTheTop = react.useMemo(function() {
        if (false) {}
        var scrollPercent = scrollTop / verticalHeight * 100;
        return scrollPercent <= 0;
    }, [
        scrollTop,
        verticalHeight
    ]);
    return {
        isAtTheTop: isAtTheTop,
        isScrollingUp: isScrollingUp
    };
}
var browsersNamePattern = /(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i;
var getBrowserNameAndVersion = function getBrowserNameAndVersion() {
    try {
        if ( true && typeof window.navigator === "object") {
            var browserMatches = window.navigator.userAgent.match(browsersNamePattern) || [];
            if (/trident/i.test(browserMatches[1])) {
                var tem = /\brv[ :]+(\d+)/g.exec(window.navigator.userAgent) || [];
                return {
                    name: "IE",
                    version: tem[1] || 0
                };
            }
            if (browserMatches[1] === "Chrome") {
                var operaVersionMatch = window.navigator.userAgent.match(/\bOPR|Edge\/(\d+)/);
                if (operaVersionMatch !== null) {
                    return {
                        name: "Opera",
                        version: operaVersionMatch[1]
                    };
                }
            }
            var nameAndVersionMatch = browserMatches[2] ? [
                browserMatches[1],
                browserMatches[2]
            ] : [
                navigator.appName,
                navigator.appVersion,
                "-?"
            ];
            var versionRegexMatch = window.navigator.userAgent.match(/version\/(\d+)/i);
            if (versionRegexMatch !== null) {
                nameAndVersionMatch.splice(1, 1, versionRegexMatch[1]);
            }
            var browsername = nameAndVersionMatch[0];
            var version = parseFloat(nameAndVersionMatch[1]);
            if (!Number.isNaN(version)) {
                return {
                    name: browsername,
                    version: version
                };
            }
        }
    } catch (error) {
    // Failed to get browser version
    }
    return null;
};
var shouldRender = function shouldRender() {
    var browser = getBrowserNameAndVersion();
    var shouldSendTrue = !browser || /safari/ig.test(browser.name) && typeof browser.version === "number" && browser.version < 12;
    if (typeof IntersectionObserver === "undefined") {
        return true;
    }
    return shouldSendTrue;
};
function useOnScreen(ref) {
    var _a = __read(react.useState(shouldRender()), 2), isIntersecting = _a[0], setIntersecting = _a[1];
    react.useEffect(function() {
        if (!isIntersecting && ref.current) {
            try {
                var observer_1 = new IntersectionObserver(function(entries) {
                    entries.forEach(function(entry) {
                        return setIntersecting(function(visible) {
                            return visible || entry.isIntersecting;
                        });
                    });
                });
                observer_1.observe(ref.current);
                // Remove the observer as soon as the component is unmounted
                return function() {
                    observer_1.disconnect();
                };
            } catch (err) {
                console.log("useOnScreen failed: ".concat(err));
                setIntersecting(true);
            }
        }
    }, [
        ref,
        isIntersecting
    ]);
    return isIntersecting;
}
function useIsAtTheTop(_a) {
    var _b = _a.id, id = _b === void 0 ? "" : _b;
    var _c = __read(react.useState(0), 2), scrollTop = _c[0], setScrollTop = _c[1];
    var _d = __read(react.useState(1), 2), verticalHeight = _d[0], setVerticalHeight = _d[1];
    react.useEffect(function() {
        var onScroll = function onScroll(e) {
            if (typeof document !== "undefined" && "object" !== "undefined") {
                var currentScrollTop = window.scrollY;
                var currentVerticalHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
                setScrollTop(currentScrollTop);
                setVerticalHeight(currentVerticalHeight);
            }
        };
        if (typeof document !== "undefined" && "object" !== "undefined") {
            window.addEventListener("scroll", onScroll);
            return function() {
                return window.removeEventListener("scroll", onScroll);
            };
        }
    }, [
        id,
        scrollTop,
        verticalHeight
    ]);
    var isAtTheTop = react.useMemo(function() {
        var scrollPercent = scrollTop / verticalHeight * 100;
        return scrollPercent <= 0;
    }, [
        scrollTop,
        verticalHeight
    ]);
    return isAtTheTop || "object" === "undefined";
}
exports.F4 = useIsAtTheTop;
exports.Or = useIsVisible;
__webpack_unused_export__ = useOnScreen;
exports.d8 = useScrollWatcher; //# sourceMappingURL=hooks.js.map


/***/ })

}]);